export default "__VITE_ASSET__ClMEqUvi__"